import { AppState } from '../../../reducers/index';
import { createSelector } from '@ngrx/store';
import * as fromServicePercentageSchemeReducer from './service-percentage-scheme.reducer';

export const currentState = (state: AppState) => (state[fromServicePercentageSchemeReducer.servicePercentageSchemesFeatureKey]);

export const selectAllServicePercentageSchemes = createSelector(currentState, fromServicePercentageSchemeReducer.selectAll);

export const selectTotalServicePercentageSchemes = createSelector(currentState, fromServicePercentageSchemeReducer.selectTotal);

export const selectModifiedServicePercentageSchemes = createSelector(selectAllServicePercentageSchemes, (servicePercentageSchemes) => {
  return servicePercentageSchemes.map((servicePercentageScheme) => {
    return {
      ...servicePercentageScheme
    };
  });
});
